import { callPostExternalApi, callPutExternalApi } from '@ctn/axios-util';

import { processError } from '@/utils/axiosErrors';
import axiosInstance from '@/utils/axiosInterceptor';

const getBackendUrlMensajes = () => ({
	GET_LISTADO: '/notificaciones/listado',
	PUT_MESSAGE_LEIDO: '/notificaciones/actualiza-lectura',
	PUT_MESSAGE_ARCHIVADO: '/notificaciones/actualiza-archivada',
});

const getListadoMensajes = async (data: any) =>
	callPostExternalApi({
		axiosInstance,
		data,
		withCredentials: true,
		url: getBackendUrlMensajes().GET_LISTADO,
		processError,
	});

const putMessageEstado = async (data: any) =>
	callPutExternalApi<string>({
		axiosInstance,
		data,
		withCredentials: true,
		url: getBackendUrlMensajes().PUT_MESSAGE_LEIDO,
		processError,
	});

const putMessageArchivado = async (data: any) =>
	callPutExternalApi<string>({
		axiosInstance,
		data,
		withCredentials: true,
		url: getBackendUrlMensajes().PUT_MESSAGE_ARCHIVADO,
		processError,
	});

export { getListadoMensajes, putMessageEstado, putMessageArchivado };
